// extracted by mini-css-extract-plugin
export default {"dialogContent":"avv-modal__dialogContent___FmJUp","container":"avv-modal__container___js0EN"};